import React, { useEffect, useRef, useState } from 'react';
import { ModalWraper } from '../UI/styledConstants';
import IconClose from '../../assets/images/IconClose';
import logoBlack from '../../assets/images/logoBlack.svg';
import backgroundImg from '../../assets/images/bg-img.png';
import { clickOutside, downloadDivAsImage, numberToWords, overLayers } from '../../utils/common';
import successImg from '../../assets/images/successimg.png';

function RechargeReceipt({ closePop,  rechargDataResp }) {

    const [customCss, setCustonCss] = useState({});
	const heightCss = {
		height: '150px',
	};

	const handleDownloadClick = (title) => {
		setCustonCss({ height: 'auto' });
		setTimeout(() => {
			const divElement = document.getElementById('model');
			downloadDivAsImage(divElement, title, setCustonCss, heightCss);
		});
	};

	const handleCopy = (e, value) => {
		let target = e.target;

		navigator.clipboard
			.writeText(value)
			.then(() => {
				target.classList.add('active');

				(function (param) {
					setTimeout(() => {
						param.classList.remove('active');
					}, 1500);
				})(target);
			})
			.catch((err) => {
				console.error('Failed to copy text:', err);
			});
	};
	const regExpDebit = /^D/i;

	
		const boxRef = useRef(null);
		useEffect(() =>{
			overLayers(true);
			clickOutside(true,boxRef,closePop);
		
			return(() =>{
				overLayers(false)
				clickOutside(false,boxRef,closePop);
			})
		
		},[]);
	

    return (
		<ModalWraper url={backgroundImg}>
			<div className="modal modal-success modal-body-aeps" id="model" ref={boxRef}>
				<div className="flex modal-header justify-between">
					<div className="logo">
						<img src={logoBlack} alt={'logo'} />
						<div>
							<p>Invoicing and payments</p>
							<p>powered by Pay2Mobile</p>
						</div>
					</div>

					<div className="buttons">
						<button className="button-solid" style={{ marginRight: '8px' }} onClick={() => handleDownloadClick('Recharge receipt')}>
							Download
						</button>
						<button className="button-solid" onClick={() => window.print()}>
							Print
						</button>
					</div>
				</div>
				<div className="modal-close" onClick={closePop}>
					<IconClose />
				</div>
				
		
					<div className="text-center modal-title">
						<h2 className="transactionMsg">{rechargDataResp?.msg ==="SUCCESS"?"Recharge Successful!":rechargDataResp?.msg ==="PENDING"?"Transaction in pending":""}</h2>
						<h3 className="amount">₹ {rechargDataResp?.amount}</h3>
						<p className="amount-text">{numberToWords(rechargDataResp?.amount)}</p>
					</div>
			

				<div className="modal-body ">
					<div className="txn-daital">
						<div className="flex justify-between txn-daital-h">
							<div>Send To</div>
							<div></div>
						</div>
					
							<div className="flex justify-between txn-desc">
								<div className="txn-desc-right">
									<div>
										<span>Status</span>
									</div>
								</div>
								<div className="txn-desc-left">
									<div>
										<span>
											<div className="detail-desc success">
												{rechargDataResp?.msg ==="SUCCESS"?<><img src={successImg} alt={"success"} />SUCCESS</>
												:rechargDataResp?.msg ==="PENDING"?"PENDING":"FAILED "}
												
											</div>
										</span>
									</div>
								</div>
							</div>
					
						<div className="flex justify-between txn-desc">
							<div className="txn-desc-right">
								<div>
									<span>Mobile Number</span>
								</div>
							</div>
							<div className="txn-desc-left">
								<div>
									<span>{rechargDataResp?.account}</span>
								</div>
							</div>
						</div>
                        <div className="flex justify-between txn-desc">
							<div className="txn-desc-right">
								<div>
									<span>Recharge Amount</span>
								</div>
							</div>
							<div className="txn-desc-left">
								<div>
									<span>₹ {rechargDataResp?.amount}</span>
								</div>
							</div>
						</div>
						<div className="flex justify-between txn-desc">
							<div className="txn-desc-right">
								<div>
									<span>Date And Time</span>
								</div>
							</div>
							<div className="txn-desc-left">
								<div>
									<span>{new Date(rechargDataResp?.date).toLocaleString()}</span>
								</div>
							</div>
						</div>
						<div className="flex justify-between txn-desc">
							<div className="txn-desc-right">
								<div>
									<span>Transaction ID</span>
								</div>
							</div>
							<div className="txn-desc-left">
								<div>
									<span>{rechargDataResp?.agentid}</span>
								</div>
							</div>
						</div>
						<div className="flex justify-between txn-desc">
							<div className="txn-desc-right">
								<div>
									<span>Reference No.</span>
								</div>
							</div>
							<div className="txn-desc-left">
								<div>
									<span>{rechargDataResp?.rpid}</span>
								</div>
							</div>
						</div>
						
						
					</div>
				
				</div>
			</div>
		</ModalWraper>
	);
}

export default RechargeReceipt;
